const tabs = [
    {
        key: "overview",
        label: "Overview"
    },
    {
        key: "states",
        label: "States"
    },
    {
        key: "counties",
        label: "Counties"
    },
    {
        key: "fields",
        label: "Fields"
    },
    {
        key: "leases",
        label: "Leases"
    },
    {
        key: "bore-profiles",
        label: "Bore Profiles"
    },
    {
        key: "operators",
        label: "Operators"
    },
    {
        key: "types",
        label: "Types"
    },
    {
        key: "statuses",
        label: "Statuses"
    },
    {
        key: "primary-formations",
        label: "Primary Formations"
    },
    {
        key: "basins",
        label: "Basings"
    },
    {
        key: "vintage",
        label: "Vintage"
    },
    {
        key: "custom-charts",
        label: "Custome Charts"
    },
    {
        key: "monthly-production",
        label: "Monthly Production"
    },
    {
        key: "type-curves",
        label: "Type Curves"
    },
    {
        key: "economics",
        label: "Economics"
    }
];

export default tabs;